import { render, staticRenderFns } from "./aroundListNew.vue?vue&type=template&id=05b638c6&scoped=true"
import script from "./aroundListNew.vue?vue&type=script&lang=js"
export * from "./aroundListNew.vue?vue&type=script&lang=js"
import style0 from "./aroundListNew.vue?vue&type=style&index=0&id=05b638c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b638c6",
  null
  
)

export default component.exports